export function addSmoothScrollingToAnchors() {
  const anchors: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('a[href^="#"]');
  anchors.forEach((anchor: HTMLAnchorElement) => {
    anchor.addEventListener('click', anchorSmoothScroll);
  });
}

function anchorSmoothScroll(this: HTMLAnchorElement, event: MouseEvent) {
  event.preventDefault();
  const destinationName: string | null = this.getAttribute('href');
  if (destinationName && destinationName != '#') {
    const destinationEl: HTMLElement | null = document.querySelector(destinationName);
    if (destinationEl) {
      destinationEl.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }
}
